import { createSlice } from '@reduxjs/toolkit';
import { getUserLoyaltyExperience } from './actions';

const initialState = {
  data: {},
  isLoading: false,
  isError: false,
  errorMessage: {},
};

export const userLoyaltyExperience = createSlice({
  name: 'userLoyaltyExperience',
  initialState,
  reducers: {
    // reducers goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserLoyaltyExperience.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.data = {};
      })
      .addCase(getUserLoyaltyExperience.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getUserLoyaltyExperience.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      });
  },
});

export default userLoyaltyExperience.reducer;
